import { DateTime, DateTimePrecision, isSameTimeOrAfter, isSameTimeOrBefore } from "@hex-insights/core";

// TODO move to core
export function isBetweenTimes(date: DateTime, start: DateTime, end: DateTime, precision?: DateTimePrecision) {
	return isSameTimeOrAfter(date, start, precision) && isSameTimeOrBefore(date, end, precision);
}
